import PropTypes from "prop-types";
import React from "react";
import Tooltip from "react-tooltip-lite";
import classnames from "classnames";
import style from "./hint-bubble.css";

function HintBubble(props) {
  var className = classnames(style.hintBubbleWrapper, props.className);
  var content = React.createElement("div", {
    className: style.hintBubbleTooltipWrapper
  }, props.tooltipText);
  return React.createElement(Tooltip, {
    background: "#333",
    className: className,
    content: content,
    direction: "down",
    padding: "0",
    tipContentHover: true
  }, React.createElement("span", {
    className: style.hintBubble
  }));
}

export default HintBubble;
HintBubble.propTypes = {
  className: PropTypes.string,
  tooltipText: PropTypes.node.isRequired
};